import styles from "./CardContent.module.css";

export type CardContentProps = {
  children: React.ReactNode;
};

export const CardContent = ({ children }: CardContentProps) => (
  <div className={styles["card-content"]}>
    <div className={styles["card-body"]}>{children}</div>
  </div>
);
